module.exports = __webpack_public_path__ + "static/media/case.b54f1eb7.png";